import { Link as GatsbyLink, graphql } from 'gatsby'
import { useLocation } from '@reach/router'
import { getLocale, localizedPath } from '@plugins/bw-i18next/utils'
import { smoothScroll } from '@/utils/dom'
import { excludedPages } from '@/utils/tracking'

export const fragment = graphql`
  fragment Link on ContentfulComponentLink {
    __typename
    contentful_id
    url
  }
`

export default function LinkComponent({ children, to, scrollToOffset = undefined, ...other }) {
  if (!to) return <span {...other}>{children}</span>

  const { pathname } = useLocation()

  const localPath = localizedPath(to, getLocale(pathname))

  // hash links to the current page but happen to include the whole path should have that axed
  const toPath = localPath.startsWith(`${pathname}#`) ? localPath.substring(pathname.length + 0) : localPath

  const isExcludedTrackingPage = excludedPages.includes(toPath) || excludedPages.includes(pathname)

  // internal hash links
  if (toPath.startsWith('#')) {
    return (
      <a
        href={toPath}
        onClick={(e) => {
          const target = document.getElementById(toPath.substring(1))
          if (target && getComputedStyle(target)?.display === 'none') target.style.display = 'block'
          scrollToOffset ? smoothScroll(e, scrollToOffset) : smoothScroll(e)
        }}
        {...other}
      >
        {children}
      </a>
    )
  }

  // internal links to non-static paths
  if (toPath.startsWith('/') && !toPath.startsWith('//')) {
    return toPath.includes('#') || isExcludedTrackingPage ? ( // lame gatsby bug
      <a href={toPath} {...other}>
        {children}
      </a>
    ) : (
      <GatsbyLink to={toPath} {...other}>
        {children}
      </GatsbyLink>
    )
  }

  // everything else is an external link or resource, open in a new tab
  return (
    <a href={toPath} target="_blank" rel="noreferrer" {...other}>
      {children}
    </a>
  )
}
